<template>
<div class="conversation-text" :class="float === 'right' ? 'ml-0':'mr-0'">
    <div class="ctext-wrap">
        <p class="mb-2 font-12">{{ chat.content }}</p>
        <chat-files v-if="chat.files && chat.files.length" :list="chat.files"/>
        <p class="mb-2 pb-2 border-bottom"> <small style='font-size:10px;'>{{ chat.created_at | date_ago }}</small></p>
        <div v-if="chat.replyer_id" class="mb-2 py-2 text-right">
            <h6 class="font-weight-bold text-inherit font-italic text-right">{{chat.who == 'admin'? 'Buyer' : 'You'}} Replied:</h6>
            <p class="mb-2 text-right">{{chat.reply}}</p>
            <small style='font-size:10px;'>{{ chat.replied_at | date_ago }}</small>
        </div>
        <slot v-else name="footer-action"></slot>
    </div>
</div>
</template>

<script>
import ChatFiles from './ChatFiles';

export default {
    components:{
        ChatFiles
    },
    props:{
        chat:{
            type:Object,
            required:true
        },
        float:{
            type: String,
            required:true
        }
    },
    computed: {

    },

};
</script>


<style>


</style>
